import { render, staticRenderFns } from "./BaseFullscreenModal.vue?vue&type=template&id=358b9722"
import script from "./BaseFullscreenModal.vue?vue&type=script&lang=js"
export * from "./BaseFullscreenModal.vue?vue&type=script&lang=js"
import style0 from "./BaseFullscreenModal.vue?vue&type=style&index=0&id=358b9722&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports